<template>
  <div class="sjcj">
    <div class="card1">
      <div class="w1280">
        <div style="padding: 112px 0;">
          <div class="t11">新零售与电商AI数据解决方案</div>
          <div class="t22">
            行业领先的标注平台和全面的数据服务，支持您的新零售与电商AI数据需求
          </div>
          <div class="btn1" style="margin: 0 auto;" @click="go('/callMe')">咨询数据解决方案</div>
        </div>
      </div>
    </div>
    <div class="w1280" style="margin: 48px auto;">
      <div class="flexs">
        <div style="width: 48%;">
          <div class="title-1">全面支持您的新零售及电商需求</div>
          <div class="title-2">提供全面的数据服务支持，包括LLM训练支持，为新零售及电子商务AI完成了上百个项目的交付，为您的国内及海外AI应用场景提供全流程数据服务。</div>
          <ul>
            <li>超过 7 年的行业专业知识</li>
            <li>与领先的电子商务公司合作</li>
            <li>在用例方面拥有深厚的专业知识，包括搜索相关性、个性化、聊天机器人训练等</li>
          </ul>
        </div>
        <div style="width: 48%;">
          <img style="width: 100%;border-radius:16px" src="../assets/img/sjfw/dzsw.webp" alt="">
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">应用场景：新零售和电子商务AI</div>
      
      <div class="w1280" style="margin-top:48px">
        <div class="flexs" style="flex-wrap: wrap;">
          <div class="card-sx" v-for="(item, index) in cardList" :key="index">
            <img
              style="width: 405px;height: 192px;border-radius:8px 8px 0 0;object-fit: cover; object-position: top;"
              :src="item.img"
              alt=""
            />
            <div class="contents">
              <div class="t1">{{ item.title }}</div>
              <div
                v-for="(item1, index1) in item.textList"
                :key="index1"
                class="t2"
              >
                {{ item1.title }}<span class="t3">{{ item1.content }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">数据解决方案</div>
      <div class="slogan">提供全面的数据采集和标注服务，涵盖全球多国家地区以及多语言，支持您的新零售及电子商务的AI数据需求。</div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 45%;">
            <div class="t1">数据采集定制服务</div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 50%;">
                <ul>
                  <li>人脸采集</li>
                  <li>商品图采集</li>
                  <li>服装图采集</li>
                  <li>虚拟人采集</li>
                  <li>居家环境采集</li>
                  <li>物流及仓储数据采集</li>
                </ul>
              </div>
              <div style="width: 50%;">
                
              </div>
            </div>
            <div class="btn1" @click="go('/callMe')">
              咨询定制标注服务
              <i class="el-icon-right"></i>
            </div>
          </div>
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/dmx.webp"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/hw.webp"
              alt=""
            />
          </div>
          <div style="width: 45%;">
            <div class="t1">数据标注定制服务</div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 50%;">
                <ul>
                  <li>搜索相关性推荐</li>
                  <li>商品审核</li>
                  <li>人脸标注</li>
                  <li>动作标注</li>
                  <li>商品货架标注</li>
                  <li>物流标注</li>
                  <li>票据OCR标注</li>
                </ul>
              </div>
              <div style="width: 50%;">
               
              </div>
            </div>
            <div class="btn1" @click="go('/callMe')">
              项目咨询
              <i class="el-icon-right"></i>
            </div>
          </div>
          
        </div>
      </div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 45%;">
            <div class="t1">大模型数据服务</div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 50%;">
                <ul>
                  <li>微调数据集定制</li>
                  <li>大模型开发平台</li>
                  <li>RLHF服务</li>
                  <li>Prompt Engineering服务</li>
                  <li>大模型定制开发服务</li>
                </ul>
              </div>
              <div style="width: 50%;">
               
              </div>
            </div>
            <div class="btn1" @click="go('/callMe')">
              咨询大模型服务
              <i class="el-icon-right"></i>
            </div>
          </div>
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/asd.webp"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">我们的优势</div>
      <div class="w1280" style="">
        <div class="flexs" style="flex-wrap: wrap;margin:32px 128px">
          <div class="card-ys" v-for="(item, index) in ysList" :key="index">
            <img style="width:48px;height:48px;margin-bottom:8px" :src="item.img" alt="" />
            <div class="t1">{{item.name}}</div>
            <div class="t2">{{item.content}}</div>
          </div>
        </div>
      </div>
      </div>
    <div class="card-footer">
      <div class="t1">覆盖全球市场的AI数据服务能力</div>
      <div class="t2">为您的新零售及电子商务AI提供全面数据支持</div>
      <div class="btns" @click="go('/callMe')">联系我们</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ysList:[
        {
          name: "一站式数据管理",
          content:
            "我们已经成功交付多种类互联网AI数据项目，提供采集、数据清洗、数据标注、模型测试的一站式数据管理服务。",
          img: require("../assets/img/sjfw/e1.svg"),
        },
        {
          name: "全球团队",
          content:
            "在海内外拥有众多众包，同时在海外也有自有标注基地，为您的出海项目提供全面支持。",
          img: require("../assets/img/sjfw/e2.svg"),
        },
        {
          name: "质量交付",
          content:
            "我们的高质量要求已经服务过数百个项目并维持99%的平均初始数据通过率，为您提供高质量数据服务。",
          img: require("../assets/img/sjfw/e3.svg"),
        },
        {
          name: "数据安全",
          content:
            "通过了ISO27001,ISO9001与ISO27701，以及EHS证书，同时搭建了多个合规室/安全屋，同时有1000+内部标注员为您的高安全要求提供支持。",
          img: require("../assets/img/sjfw/e4.svg"),
        },],
      cardList1: [
        {
          name: "数据存储与传输",
          list:[{t:'国安级加密云技术保证数据传输和存储安全'},{t:'业界领先的Appen Secure Workspace可确保在家办公环境达到与安全设备相同的安全级别'}],
          img: require("../assets/img/sjfw/x1.svg"),
        },
        {
          name: "项目现场与监管",
         list:[{t:'项目现场配置人脸识别和指纹门禁'},{t:'设有加密项目房间，仅授权人员准许进入 Secure Workspace可确保在家办公环境达到与安全设备相同的安全级别'},{t:'配有24*7值班人员以及无死角摄像头监控现场'}],
          img: require("../assets/img/sjfw/x2.svg"),
        },
        {
          name: "雇员与被采人管控",
          list:[{t:'标注人员及供应商签署保密协议'},{t:'全体员工办公设备均统一管理'}],
          img: require("../assets/img/sjfw/x3.svg"),
        }
      ],
      cardList: [
        {
          title: "无人售货",
          img: require("../assets/img/sjfw/k1.webp"),
          textList: [
            {
              title: "",
              content: "无人售货商店、自助结账与无人售货机现在已广泛存在于各大商场及商超。其中，人脸识别支付、货物识别、货架内容识别等是重要的AI程序。针对每种商品的图像、价格、货架位置的数据采集、标注、以及后台标签对齐，我们可以提供全面数据服务。",
            }
          ],
        },
        {
          title: "商品识图",
          img: require("../assets/img/sjfw/k2.webp"),
          textList: [
            {
              title: "",
              content: "线下的货架商品识别，以及线上的寻找类似商品等，商品识图是重要的AI程序。我们提供定制采集及标注服务，包括服装的具体版型标注、图片分类、类似图片判断等，助您开发高质量高效的AI程序。",
            },
           
          ],
        },
        {
          title: "智能客服",
          img: require("../assets/img/sjfw/k3.webp"),
          textList: [
            {
              title: "",
              content:"针对大量在线咨询，利用LLM开发的定制智能客服已经成为业界最新趋势。我们提供全系列RAG训练数据支持，定制化数据集，以及大模型微调平台，并可为您定制大模型智能客服，为您减少客服人员需求，降本增效。",
            },
          ],
        },
        {
          title: "语义搜索",
          img: require("../assets/img/sjfw/k4.webp"),
          textList: [
            {
              title: "",
              content:
                "由于在线搜索习惯愈发琐碎、长尾词的使用愈加普遍，AI辅助的语义搜索成为APP内搜索的重要支持。我们28年的语言语义服务经验，让我们可以为您进行多语言、多语种、多类型、多语境的语义匹配、语义搜索、搜索相关性数据支持。",
            },
            
          ],
        },
        {
          title: "AR换装",
          img: require("../assets/img/sjfw/k5.webp"),
          textList: [
            {
              title: "",
              content:
                "AR换装、换“妆”、AR“装修”已经出现在诸多APP和智能终端中，使消费者可以直观地感受到商品的适配性、增加商品下单率。我们提供多光线、肤色、体型、服装版型等的数据支持，为您部署应用、提升AR效果提供全流程支持。",
            },
            
          ],
        },
        {
          title: "智能仓储物流",
          img: require("../assets/img/sjfw/k6.webp"),
          textList: [
            {
              title: "",
              content:
                "由于电商购物的量级逐渐提高，“无人配送”“无人物流中心”已经成为降本增效的重要举措。我们提供物流中心、仓储管理、配送机器人等应用的全面数据支持，包括数据采集及清洗、数据标注、模型测试反馈等全流程服务。",
            },
            
          ],
        },
      ],
    };
  },
  methods: {
    go(path) {
      this.$router.push(path);
    }
  },
};
</script>
<style lang="scss" scoped>
.sjcj {
  .card1 {
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    width: 100%;
    height: 450px;
  }
  .card4 {
    width: 1280px;
    margin: 48px auto;
    text-align: center;
    .item-card2{
      flex-shrink: 0;
      text-align: center;
      width: 340px;
      margin: 40px 30px ;
    }
    .item-card {
      height: 240px;
      flex-shrink: 0;
      padding: 40px 24px;
      background-color: #eceff0;
      border-radius: 8px;
      width: 360px;
      margin-top: 20px;
      text-align: left;
      font-size: 16px;
    }
    .select-tab {
      margin: 30px 0 20px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 38px;
      line-height: 38px;
      align-content: center;
      padding: 2px;
      border-radius: 25px;
      border-width: 1px;
      border-style: solid;
      border-color: #000;
      border-image: initial;
      .s-tabs {
        width: 20%;
        height: 38px;
        text-align: center;
        cursor: pointer;
        border-radius: 25px;
      }
      .is-active {
        color: rgb(255, 255, 255);
        background: #045588;
      }
    }
    .card4-t1 {
      color: #045588;
      font-size: 48px;
      font-weight: bold;
    }
    .card4-t2 {
      font-size: 16px;
      width: 680px;
      margin: 24px auto 0;
      line-height: 1.5;
    }
    .card4-t3 {
      font-size: 32px;
      text-align: left;
      margin-bottom: 56px;
      color: #045588;
      font-weight: bold;
    }
    .btns {
      cursor: pointer;
      margin-top: 32px;
      width: 150px;
      background-color: #099fee;
      color: #fff;
      height: 48px;
      line-height: 48px;
      padding: 0 20px;
      border-radius: 8px;
    }
  }
  .card2 {
    width: 1280px;
    margin: 0 auto;
    .card-ys{
      width:448px;
      height:178px;
      padding: 24px;
      background-color: #eceff0;
      border-radius: 8px;
      margin-top:24px;
      .t1{
        font-size:20px;
        color: #25282a;
        margin-bottom: 16px;
      }.t2{
        font-size:16px;
        color: #25282a;
      }
    }
    .card-sx {
      width: 405px;

      margin: 0 0 48px;
      .contents {
        padding: 24px;
        height: 228px;
        background-color: #eceff0;
        border-radius: 0 0 8px 8px;
        .t1 {
          color: #045588;
          font-size: 24px;
          font-weight: 500;
          margin-bottom: 32px;
        }
        .t2 {
          color: #4b4f54;
          font-weight: bold;
          font-size: 16px;
          line-height: 1.5;
        }
        .t3 {
          font-weight: normal;
        }
      }
    }
    li {
      line-height: 1.5;
    }
    .t1 {
      color: #045588;
      font-size: 32px;
      margin-bottom: 16px;
      font-weight: 500;
    }
    .title {
      color: #045588;
      text-align: center;
      margin-top: 64px;
      font-weight: 500;
      font-size: 48px;
      margin-bottom: 8px;
    }
    .slogan {
      color: rgb(75, 79, 84);
      font-size: 16px;
      text-align: center;
      line-height: 1.2;
      width: 768px;
      margin: 0 auto 64px;
    }
  }
  .card-footer {
    width: 100%;
    height: 328px;
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    .t1 {
      color: rgb(0, 126, 204);
      font-weight: 500;
      font-size: 50px;
      text-align: center;
      padding-top: 60px;
    }
    .t2 {
      text-align: center;
      margin-top: 24px;
    }
    .btns {
      cursor: pointer;
      text-align: center;
      background-image: linear-gradient(
        260.38deg,
        #099fee 3.89%,
        #2247da 143.13%
      );
      width: 96px;
      height: 48px;
      padding: 0 16px;
      line-height: 48px;
      color: #fff;
      margin: 24px auto 0;
      border-radius: 8px;
    }
  }
  .btn1 {
    cursor: pointer;
    width: 250px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #fff;
    background-color: #099fee;
    border-radius: 8px;
  }
  .w1280 {
    width: 1280px;
    margin: 0 auto;
    .t11 {
      color: #045588;
      font-size: 56px;
      font-weight: bold;
      line-height: 84px;
      text-align: center;
    }
    .t22 {
      margin: 32px 256px;
      text-align: center;
      font-size: 20px;
      color: #4b4f54bf;
    }
    .title-1{
      color: #045588;
      font-size: 32px;
      margin-bottom: 16px;
    }
    .title-2{
      font-size:16px;
      line-height: 1.5;
    }
    li{
      margin-left: 24px;
      line-height: 1.5;
    }
  }
  .flexs {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
<style></style>
